import { render, staticRenderFns } from "./StatsPayment.vue?vue&type=template&id=1797d8ea"
import script from "./StatsPayment.vue?vue&type=script&lang=js"
export * from "./StatsPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports